import { useMemo } from 'react';
import useAuth from './useAuth';

export default function useRules() {
  const { user } = useAuth();
  const rules = useMemo(() => user?.rules ?? [], [user?.rules]);
  console.log('user?.role?.name', user?.role?.name)

  const hasRule = (rule: string) => rules.includes(rule);
  const hasAnyRule = (requiredRules: string[]) =>
    requiredRules.length === 0 || requiredRules.some((r) => rules.includes(r));
  const isAdmin = hasRule('administrator');
  const isClient =
    !isAdmin &&
    (hasRule('orders.read') || hasRule('orders.create')) &&
    !hasRule('customers.read');
  const isExternalClient = Boolean(user?.role?.name === 'Cliente');

  return { rules, hasRule, hasAnyRule, isAdmin, isClient, isExternalClient };
}
